// @notranslate
export {default} from 'Components/Accordion/Accordion'
